<template>
  <basic-container>
    <el-row>
      <el-col :span="24">
        <div style="background-color: white;">
          <div style="color: #999999; font: 16px Chinese Quote; padding: 15px;">
            房产资源
          </div>
          <avue-data-display :option="roomOption"></avue-data-display>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12" style="box-sizing: border-box; padding-right: 4px;">
        <div style="background-color: white;">
          <div style="color: #999999; font: 16px Chinese Quote; padding: 15px;">
            物业账单
          </div>
          <div>
            <el-row>
              <el-col :span="12">
                <avue-echart-pie
                  :option="wyBillCountOption"
                  :data="wyBillCountData"
                  width="100%"
                  height="180"
                  style="margin-top: -5px;"
                >
                </avue-echart-pie>
                <div style="text-align: center; color: #999999; font: 8px Chinese Quote;">
                  上月待收账单(笔) <br />
                  {{ wyBillTotalCount }}
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <avue-echart-pie
                    :option="wyBillMoneyOption"
                    :data="wyBillMoneyData"
                    width="100%"
                    height="180"
                    style="margin-top: -5px;"
                  ></avue-echart-pie>
                  <div style="text-align: center; color: #999999; font: 8px Chinese Quote;">
                    上月待收金额(元) <br />
                    ￥{{ wyBillTotalMoney }}
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span="12" style="box-sizing: border-box; padding-left: 4px;">
        <div style="background-color: white;">
          <div style="color: #999999; font: 16px Chinese Quote; padding: 15px;">
            <el-row>
              <el-col :span="18">
                收费情况
              </el-col>
              <el-col :span="6">
                <el-radio-group
                  @change="radioBtnChange"
                  v-model="radioDayGroup"
                  :fill="radioBtnColor"
                  size="mini"
                >
                  <el-radio-button label="1">今日</el-radio-button>
                  <el-radio-button label="2">7日</el-radio-button>
                  <el-radio-button label="3">30日</el-radio-button>
                </el-radio-group>
              </el-col>
            </el-row>
          </div>
          <div>
            <el-row>
              <el-col :span="12">
                <div>
                  <avue-echart-pie
                    :option="sfCountOption"
                    :data="sfCountData"
                    width="100%"
                    height="180"
                    style="margin-top: -20px;"
                  ></avue-echart-pie>
                  <div style="text-align: center; color: #999999; font: 8px Chinese Quote;">
                    收款(笔) <br />
                    {{ sfTotalCount }}
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div>
                  <avue-echart-pie
                    :option="sfMoneyOption"
                    :data="sfMoneyData"
                    width="100%"
                    height="180"
                    style="margin-top: -20px;"
                  ></avue-echart-pie>
                  <div style="text-align: center; color: #999999; font: 8px Chinese Quote;">
                    收款金额(元) <br />
                    ￥{{ sfTotalMoney }}
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12" style="box-sizing: border-box; padding-right: 4px;">
        <div style="background-color: white;">
          <div style="color: #999999; font: 16px Chinese Quote; padding: 15px;">
            车场信息
          </div>
          <avue-data-display :option="parkOption" style="height: 180px; padding-top: 20px;">
          </avue-data-display>
        </div>
      </el-col>
      <el-col :span="12" style="box-sizing: border-box; padding-left: 4px;">
        <div style="background-color: white;">
          <div style="color: #999999; font: 16px Chinese Quote; padding: 15px;">
            车场收费
          </div>
          <avue-echart-bar
            :option="parkFeeOption"
            :data="parkFeeData"
            width="800"
            height="200"
          ></avue-echart-bar>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div style="background-color: white;">
          <div style="color: #999999; font: 16px Chinese Quote; padding: 15px;">
            工单监控
          </div>
          <avue-data-display :option="workOrderOption"></avue-data-display>
        </div>
      </el-col>
    </el-row>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import request from '@/util/request';

export default {
  data() {
    let pieBarColor = [
      {
        color1: '#E3935D',
      },
      {
        color1: '#E16757',
      },
      {
        color1: '#61A5E8',
      },
      {
        color1: '#7ECF51',
      },
      {
        color1: '#EECB5F',
      },
    ];
    const tmpToday = new Date();
    let startToday = this.dayjs(tmpToday).format('YYYY-MM-DD') + ' 00:00:00';
    let endToday = this.dayjs(tmpToday).format('YYYY-MM-DD') + ' 23:59:59';

    const tmpLastSevenDay = new Date();
    let endLastSevenDay = this.dayjs(tmpLastSevenDay).format('YYYY-MM-DD') + ' 23:59:59';
    tmpLastSevenDay.setTime(tmpLastSevenDay.getTime() - 3600 * 1000 * 24 * 7);
    let startLastSevenDay = this.dayjs(tmpLastSevenDay).format('YYYY-MM-DD') + ' 00:00:00';

    const tmpLastMonth = new Date();
    let endLastMonth = this.dayjs(tmpLastMonth).format('YYYY-MM-DD') + ' 23:59:59';
    tmpLastMonth.setTime(tmpLastMonth.getTime() - 3600 * 1000 * 24 * 30);
    let startLastMonth = this.dayjs(tmpLastMonth).format('YYYY-MM-DD') + ' 00:00:00';

    return {
      radioBtnColor: '#409EFF',
      radioDayGroup: '1',
      startToday: startToday,
      endToday: endToday,
      startLastSevenDay: startLastSevenDay,
      endLastSevenDay: endLastSevenDay,
      startLastMonth: startLastMonth,
      endLastMonth: endLastMonth,
      roomOption: {},
      wyBillCountOption: {
        switchTheme: false,
        labelShow: true,
        radius: true,
        barColor: pieBarColor,
      },
      wyBillMoneyOption: {
        switchTheme: false,
        labelShow: true,
        radius: true,
        barColor: pieBarColor,
      },
      sfCountOption: {
        switchTheme: false,
        labelShow: true,
        radius: true,
        barColor: pieBarColor,
      },
      sfMoneyOption: {
        switchTheme: false,
        labelShow: true,
        radius: true,
        barColor: pieBarColor,
      },
      parkOption: {},
      parkFeeOption: {
        legend: true,
        legendPostion: 'center',
        legendOrient: 'horizontal',
        switchTheme: false,
        gridX: 50,
        gridY: 20,
        gridX2: 10,
        gridY2: 40,
        nameColor: '#333',
        lineColor: '#333',
        xNameFontSize: 12,
        yNameFontSize: 12,
        xAxisShow: true,
        yAxisShow: true,
        xAxisSplitLineShow: false,
        yAxisSplitLineShow: true,
        barWidth: 20,
        barRadius: 0,
        barColor: [
          {
            color1: '#61A5E8',
            color2: '#61A5E8',
          },
          {
            color1: '#7ECF51',
            color2: '#7ECF51',
          },
        ],
        barMinHeight: 1,
      },
      workOrderOption: {},
      wyBillTotalCount: {},
      wyBillCountData: [],
      wyBillTotalMoney: {},
      wyBillMoneyData: [],
      sfTotalCount: {},
      sfCountData: [],
      sfTotalMoney: {},
      sfMoneyData: [],
      parkFeeData: {},
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    radioBtnChange() {
      if ('1' == this.radioDayGroup) {
        this.radioBtnColor = '#409EFF';
        this.getToday();
      } else if ('2' == this.radioDayGroup) {
        this.radioBtnColor = '#67C23A';
        this.getLastSevenDay();
      } else if ('3' == this.radioDayGroup) {
        this.radioBtnColor = '#E6A23C';
        this.getLastMonth();
      }
    },
    getToday() {
      this.getSfCount(this.startToday, this.endToday);
      this.getSfMoney(this.startToday, this.endToday);
    },
    getLastSevenDay() {
      this.getSfCount(this.startLastSevenDay, this.endLastSevenDay);
      this.getSfMoney(this.startLastSevenDay, this.endLastSevenDay);
    },
    getLastMonth() {
      this.getSfCount(this.startLastMonth, this.endLastMonth);
      this.getSfMoney(this.startLastMonth, this.endLastMonth);
    },
    getRoomResource() {
      request
        .get('/api/v4ward/welcome/roomResource', Object.assign({}, null, {}))
        .then(({ data }) => {
          this.roomOption = data;
        });
    },
    getWYBillCount() {
      request
        .get('/api/v4ward/welcome/wyBillCount', Object.assign({}, null, {}))
        .then(({ data }) => {
          this.wyBillTotalCount = data.total;
          this.wyBillCountData = data.data;
        });
    },
    getWYBillMoney() {
      request
        .get('/api/v4ward/welcome/wyBillMoney', Object.assign({}, null, {}))
        .then(({ data }) => {
          this.wyBillTotalMoney = data.total;
          this.wyBillMoneyData = data.data;
        });
    },
    getSfCount(startPayTime, endPayTime) {
      var params = {
        startPayTime: startPayTime,
        endPayTime: endPayTime,
      };
      request
        .get('/api/v4ward/welcome/sfCountInfo', Object.assign({}, null, { params }))
        .then(({ data }) => {
          this.sfTotalCount = data.total;
          this.sfCountData = data.data;
        });
    },
    getSfMoney(startPayTime, endPayTime) {
      var params = {
        startPayTime: startPayTime,
        endPayTime: endPayTime,
      };
      request
        .get('/api/v4ward/welcome/sfMoneyInfo', Object.assign({}, null, { params }))
        .then(({ data }) => {
          this.sfTotalMoney = data.total;
          this.sfMoneyData = data.data;
        });
    },
    getParkFee() {
      request.get('/api/v4ward/welcome/parkFee', Object.assign({}, null, {})).then(({ data }) => {
        this.parkFeeData = data;
      });
    },
    getParkInfo() {
      request.get('/api/v4ward/welcome/parkInfo', Object.assign({}, null, {})).then(({ data }) => {
        this.parkOption = data;
      });
    },
    getWorkOrderInfo() {
      request
        .get('/api/v4ward/welcome/workOrderInfo', Object.assign({}, null, {}))
        .then(({ data }) => {
          this.workOrderOption = data;
        });
    },
  },
  mounted() {
    this.getRoomResource();
    this.getWYBillCount();
    this.getWYBillMoney();
    this.getToday();
    this.getParkFee();
    this.getParkInfo();
    this.getWorkOrderInfo();
  },
  created() {
    this.$nextTick(() => {
      document.querySelector('.basic-container .el-card').style.backgroundColor = '#F0F2F5';
    });
  },
};
</script>
<style scoped="scoped"></style>
